/* eslint-disable no-unused-vars */
import {
  Box, Container,
  useMediaQuery,
} from '@mui/material'
import { useDispatch, useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import CloseIcon from '@mui/icons-material/Close'
import TimerBtn from '../../components/Buttons/TimerBtn'
import computerClockIcon from '../../images/computerClock.svg'
import TitleWithBackBtn from '../../components/PageHelpers/TitleWithBackBtn'
import {
  getUsersBatchActionsStatusList,
  getUsersBatchActionsStatusListRefreshBtn,
  usersBatchActionsStatusResetAlertHandler,
} from '../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusThunk'
import LoaderWithErrorHandler from '../../components/PageHelpers/LoaderWithErrorHandler'
import { selectUsersBatchActionsStatus } from '../../redux/features/usersBatchActionsStatus/usersBatchActionsStatusSlice'
import BatchStatusList from './BatchStatusList'
import FilterSort from '../../images/FilterSort.svg'
import IconBtn from '../../components/Buttons/IconBtn'
import PageFilters from './PageFilters'
import UseTranslation from '../../hooks/UseTranslation'
import NoDataFound from '../../components/PageHelpers/NoDataFound'

const Index = () => {
  const dispatch = useDispatch()
  const usersBatchActionsStatusStore = useSelector(selectUsersBatchActionsStatus)
  const isXsScreen = useMediaQuery((theme) => theme.breakpoints.only('xs'))
  const [openFilter, setOpenFilter] = useState(false)
  const { t } = UseTranslation()

  useEffect(() => {
    dispatch(getUsersBatchActionsStatusList())
  }, [])

  const handelTimerClick = () => {
    dispatch(getUsersBatchActionsStatusListRefreshBtn())
  }

  const isFilteredArraysNotEmpty = usersBatchActionsStatusStore?.activeFilters?.length > 0

  return (
    <Container maxWidth="xl" sx={styles.container}>
      <TitleWithBackBtn
        title={
          <Box sx={styles.titleWithIcon}>
            <Box component={'img'} src={computerClockIcon} alt='computerClockIcon' />
            {t?.['Batch Actions Status']}
          </Box>
        }
        backBtnTxt={ isXsScreen ? '' : `${t?.back}`}
        customStyle={styles.header}
      >
        <TimerBtn customStyle={styles.timerBtn} onClick={handelTimerClick} />
        <IconBtn
          icon={openFilter ? <CloseIcon /> : <img src={FilterSort} alt="filter icon" />}
          onClick={() => setOpenFilter(!openFilter)}
          customStyle={styles.xsFilterButton(isFilteredArraysNotEmpty)}
        />
      </TitleWithBackBtn>
      <TimerBtn customStyle={styles.timerBtn2} onClick={handelTimerClick} />

      <PageFilters setOpenModal={setOpenFilter} openModal={openFilter} />

      <BatchStatusList />
      <NoDataFound store={usersBatchActionsStatusStore} />

      <LoaderWithErrorHandler store={usersBatchActionsStatusStore}
        resetAlertHandler={usersBatchActionsStatusResetAlertHandler} />
    </Container>

  )
}

const styles = {
  container: {
    padding: { xs: '0px', sm: '0px 25px 0px 25px', md: ' 0px 52px !important' },
  },
  header: {
    height: { xs: '50px', sm: '90px' },
    padding: { xs: '15px 0px 0px', sm: 'unset' },
    borderBottomLeftRadius: '15px',
    borderBottomRightRadius: '15px',
    margin: { xs: '-10px 10px 10px', sm: '-29px 0px 10px 0px', md: '-30px 0px 10px 0px' },
    '& > div': {
      marginTop: { xs: '5px', sm: '0px' },
      display: 'flex',
      flexDirection: { xs: 'row', sm: 'column' },
      alignItems: { xs: 'center', sm: 'unset' },
      px: { xs: '10px', sm: 'unset' },
    },
    '& .backBtn': {
      minWidth: '20px',
      m: { xs: '0 5px 0 0', sm: '5px 0' },
    },
    '& .container': {
      width: '100%',
    },
  },
  titleWithIcon: {
    ml: { xs: '-20px', sm: '30px' },
    display: 'flex',
    alignItems: 'center',
    gap: '10px',
    fontSize: { xs: '16px', sm: '24px' },
    '& img': {
      width: { xs: '20px', sm: '35px' },
      height: { xs: '20px', sm: '35px' },
      paddingRight: '5px',
    },
  },
  timerBtn: {
    marginInline: '50px',
    width: '189px',
    display: { xs: 'none', sm: 'initial' },
  },
  timerBtn2: {
    width: '90%',
    m: '10px 20px',
    display: { xs: 'initial', sm: 'none' },
  },

  sortAndFilters: { display: { xs: 'none', sm: 'flex' }, justifyContent: 'end', my: '30px' },

  xsFilterButton: (isFiltered) => ({
    display: { xs: 'initial', sm: 'none' },
    '& img': {
      height: '20px',
      width: '20px',
      filter: isFiltered && 'brightness(0) saturate(100%) invert(60%) sepia(98%) saturate(331%) hue-rotate(90deg) brightness(91%) contrast(91%)',
    },
    borderRadius: '10px',
    border: isFiltered ? '1px solid #29CC8B' : '1px solid #e2e8ee',
    backgroundColor: '#fff',
    color: 'text.hint',
    overflow: 'hidden',
  }),
}

export default Index
